import * as React from 'react';
import FacebookIcon from '@mui/icons-material/Facebook';

export const Footer = () => {
  return (
    <footer className="rn-footer">
      <div className="rn-footer-grid">
        <div className="rn-footer-col">
          <h4>Address</h4>
          <a href="https://goo.gl/maps/NBEF1seiiqLiz9Pu7" target="_blank" rel="noreferrer">
            15122 Potranco Rd<br />
            San Antonio, TX 78245
          </a>
        </div>
        <div className="rn-footer-col">
          <h4>Phone</h4>
          <a href="tel:2102549201">(210) 254-9201</a>
        </div>
        <div className="rn-footer-col">
          <h4>Social</h4>
          <a
            href="https://www.facebook.com/pg/therustynail210/"
            target="_blank"
            rel="noreferrer"
            aria-label="Facebook"
          >
            <FacebookIcon style={{ fontSize: 28 }} />
          </a>
        </div>
      </div>
      <div className="rn-copyright">© The Rusty Nail — San Antonio, Texas</div>
    </footer>
  );
};
